<template>
  <el-container
      class="wrong-question"
      v-loading="workTableLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-header>
      <!-- <Header></Header> -->
    </el-header>
    <el-main class="container-main">
      <div class="wrong-question-main">
        <div class="wrong-question-main-searchbar">
          <span @click="$router.go(-1)" class="back-button"><i class="el-icon-arrow-left"></i><i>返回</i></span>
          <el-input @change="getMistakeCollection" placeholder="请输入问卷题目" v-model="search.keywords"
                    style="width: 150px;margin-left: 10px;" size="mini" type="text">
            <i style="border-left: 1px solid #DCDFE6" slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-select @change="getMonthList" size="mini" style="margin-left: 10px;" v-model="search.yearSelect">
            <el-option label="2024" value="2024"></el-option>
            <el-option label="2023" value="2023"></el-option>
          </el-select>
          <div class="month-list">
            <div class="month-item" v-for="item in search.monthList" :key="item">
              <i :class="{'active': search.monthSelect == item}" @click="monthChange(item)">
                {{ item }}月
              </i>
            </div>
          </div>
        </div> 
        <div style="margin-top: 15px;">
          <el-table
              :empty-text="'本月暂无错题'"
              :height="tableHeight"
              :data="tableData"
              border
              style="width: 100%">
            <el-table-column
                align="center"
                prop="pageNumber"
                label="页数"
                width="180">
            </el-table-column>
            <el-table-column
                align="center"
                prop="serialNumber"
                label="题号"
                width="180">
            </el-table-column>
            <el-table-column
                align="center"
                prop="questionTitle"
                label="问卷题目"
                width="600"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="mistakeNumber"
                label="出错次数"
                width="150"
            >
              <template slot-scope="scope">
                {{ scope.row.mistakeNumber}}
                <i v-if="scope.row.mistakeTrend == 2"></i>
                <i v-if="scope.row.mistakeTrend == 1" style="font-size: 14px;color: red" class="iconfont icon-long-arrow-up"></i>
                <i v-else-if="scope.row.mistakeTrend === 0" style="font-size: 14px;color: green;display: inline-block;transform: rotate(180deg)" class="iconfont icon-long-arrow-up"></i>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="address"
                label="具体批注"
            >
              <template slot-scope="scope">
                <div class="annotations-list">
                  <div style="padding: 5px 0" @click="gotoDetail(item)" v-for="(item,index) in scope.row.annotations" :key="index">
                    {{ item.annotation }}
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <template>
        <el-backtop target=".el-table__body-wrapper"></el-backtop>
      </template>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>
<script type="text/ecmascript-6">
import Footer from '../common/Footer';
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "wrongQuestion",
  data() {
    return {
      workTableLoading: false,
      tableData: [],
      search: {
        questionnaireId: null,
        keywords: null,
        yearSelect: '2024',
        monthSelect: '3',
        monthList: []
      }
    }
  },
  computed: {
    ...mapGetters([
      "username",
      "userid",
    ]),
    tableHeight() {
      return document.body.clientHeight - 200;
    }
  },
  components: {Footer},
  mounted() {
    this.getMonthList(new Date().getFullYear())
  },
  methods: {
    ...mapMutations(["setTaskCenterId", "setTaskTitle", "setQuestion"]),
    monthChange(item) {
      this.search.monthSelect = item;
      this.getMistakeCollection()
    },
    async getMistakeCollectionAsync(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestMistakeCollectionControllerGetSeatMistakeCollection',
        params: {
          questionnaireId: p.questionnaireId,
          seatId: p.seatId,
          yearMonth: p.yearMonth,
          questionTitle: p.questionTitle,
        }
      })
      return result
    },
    getMistakeCollection() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
            params: {
              followupTaskId: this.$route.query.taskId,
            }
          }
      ).then(res => {
        this.getMistakeCollectionAsync({
          questionnaireId: res.retValue,
          seatId: sessionStorage.getItem('userid'),
          yearMonth: this.search.monthSelect ? `${this.search.yearSelect}-${this.search.monthSelect}` : null,
          questionTitle: this.search.keywords,
        }).then(qsList => {
          this.tableData = qsList.retValue
        })
      })
    },
    gotoDetail(item) {
      console.log(item);
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
            params: {
              followupTaskId: this.$route.query.taskId
            }
          }
      ).then(res => {
        this.setQuestion(res.retValue)
        this.setTaskCenterId(this.$route.query.taskId)
        this.$router.push({
          path: `/wrongQuestionDetail?followUpPatientInfoId=${item.followUpPatientInfoId}`,

        })
      })

    },
    getMonthList(year) {
      this.$store.dispatch('requestHandler', {
        fn: 'RestMistakeCollectionControllerGetTaskExistCallMonth',
        params: {
          year: year,
          followUpTaskId: this.$route.query.taskId
        }
      }).then(res => {
        console.log(res);
        this.search.monthList = res.retValue
        this.search.monthSelect = this.search.monthList[0]
        this.getMistakeCollection()
      })
    },
  }
}
</script>
<style lang="scss">
.back-button {
  width: 70px;
  background-color: #248cfa;
  display: inline-block;
  padding: 5px 10px;
  color: #fff;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

</style>
<style lang="scss" scoped>
.wrong-question-main {
  padding: 15px;

  .wrong-question-main-searchbar {
    display: flex;
    align-items: center;
  }


  .month-list {
    display: flex;
    align-items: center;

    .month-item {
      padding: 0 15px;
      cursor: pointer;

      i {
        display: inline-block;
        border-bottom: 2px solid #fff;

        &.active {
          padding: 5px 0;
          border-bottom: 2px solid #248cfa;
          color: #248cfa;
        }
      }
    }
  }
}

.annotations-list {
  > div {
    border-bottom: 1px solid #EBEEF5;
    color: #248cfa;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>